<div *ngIf="error !== undefined && !valid" [ngClass]="styleClass">
    <div class="error-msg-content">{{error}}</div>
</div>
